var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1429 6H6.57143C5.88944 6 5.23539 6.25507 4.75315 6.70911C4.27092 7.16315 4 7.77895 4 8.42105V22.9474C4 23.5895 4.27092 24.2053 4.75315 24.6593C5.23539 25.1133 5.88944 25.3684 6.57143 25.3684H18.2586C18.1807 24.9691 18.1419 24.5639 18.1429 24.1579C18.1429 22.2316 18.9556 20.3842 20.4023 19.0221C21.849 17.66 23.8112 16.8947 25.8571 16.8947C27.213 16.89 28.5452 17.2287 29.7143 17.8753V8.42105C29.7143 7.77895 29.4434 7.16315 28.9611 6.70911C28.4789 6.25507 27.8248 6 27.1429 6ZM27.1429 14.4737H16.8571H6.57143V10.8421H27.1429V14.4737ZM27.1429 19.3158V22.9474H31V25.3684H27.1429V29H24.5714V25.3684H20.7143V22.9474H24.5714V19.3158H27.1429Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditR);
export default __webpack_public_path__ + "static/media/creditR.a4412c97e18867341984a023fa8075fa.svg";
export { ForwardRef as ReactComponent };